// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__214ic","overflowing":"ReadFullNote_overflowing__oazhg"};